import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import "./web/wdyr"
import { registerSentry } from "web/services/sentry"
import { current } from "./helpers/current_helpers.js"
import ActionPanelController from "./controllers/react/action_panel_controller"
import ActivityPreviewController from "./controllers/activity_preview_controller"
import ActivityReferenceBarController from "controllers/activity_reference_bar_controller"
import AssetObjectOverviewController from "./controllers/react/asset_object_overview_controller"
import AssetTopicRecordListController from "./controllers/react/asset_topic_record_list_controller"
import AssetViewOrEditTLOController from "./controllers/react/asset_view_or_edit_tlo_controller"
import AttributeToggleController from "./controllers/attribute_toggle_controller"
import AutocompleteController from "./controllers/autocomplete_controller"
import AutocompleteCreationController from "controllers/autocomplete_creation_controller"
import AutocompleteMenuController from "./controllers/autocomplete_menu_controller"
import AutocompleteTextFieldController from "./controllers/autocomplete_text_field_controller"
import AutoDownloadController from "./controllers/auto_download_controller"
import BrowserTimeZoneController from "./controllers/browser_time_zone_controller"
import FlashElementController from "./controllers/flash_element_controller"
import ToastController from "./controllers/toast_controller"
import FocusNewItemController from "./controllers/focus_new_item_controller"
import FilePreviewController from "./controllers/file_preview_controller"
import ChartController from "./controllers/react/chart_controller"
import CheckboxGroupController from "./controllers/checkbox_group_controller"
import CheckboxSelectAllController from "./controllers/checkbox_select_all_controller"
import ChildPortfoliosObjectListController from "./controllers/react/child_portfolios_object_list_controller"
import ChildFrameNavigatorController from "./controllers/child_frame_navigator_controller"
import ClassReplacementController from "./controllers/class_replacement_controller"
import ClassToggleController from "./controllers/class_toggle_controller"
import ClipboardController from "./controllers/clipboard_controller"
import CompaniesObjectListController from "./controllers/react/companies_object_list_controller"
import ComparableDealAssetObjectOverviewController from "controllers/react/comparable_deal_asset_object_overview_controller"
import ComparableDealAssetViewOrEditTLOController from "controllers/react/comparable_deal_asset_view_or_edit_tlo_controller"
import ComparableDealObjectOverviewController from "controllers/react/comparable_deal_object_overview_controller"
import ComparableDealViewOrEditTLOController from "controllers/react/comparable_deal_view_or_edit_tlo_controller"
import ConfirmDialogController from "controllers/confirm_dialog_controller"
import ContactsObjectTableController from "./controllers/react/contacts_object_table_controller"
import CounterpartyTableController from "controllers/counterparty_table_controller"
import CurrentAccountMonitorController from "./controllers/current_account_monitor_controller"
import DatePickerController from "./controllers/date_picker_controller"
import DateRangeSelectController from "./controllers/react/date_range_select_controller"
import DateSelectController from "./controllers/react/date_select_controller"
import DealAssetObjectOverviewController from "./controllers/react/deal_asset_object_overview_controller"
import DealAssetsController from "./controllers/react/deal_assets_controller"
import DealAssetsObjectListController from "./controllers/react/deal_assets_object_list_controller"
import DealAssetViewOrEditTLOController from "./controllers/react/deal_asset_view_or_edit_tlo_controller"
import DealBulkActionsController from "./controllers/deal_bulk_actions_controller"
import DealCounterpartiesObjectListController from "./controllers/react/deal_counterparties_object_list_controller"
import DealObjectOverviewController from "./controllers/react/deal_object_overview_controller"
import DealOrganizationOverviewController from "./controllers/react/deal_organization_overview_controller"
import DealsFindComparableDealsController from "./controllers/react/deals_find_comparable_deals_controller"
import DealTopicRecordListController from "./controllers/react/deal_topic_record_list_controller"
import DealViewOrEditTLOController from "./controllers/react/deal_view_or_edit_tlo_controller"
import DependableFrameController from "./controllers/dependable_frame_controller"
import DialogModalController from "./controllers/dialog_modal_controller"
import DragDropController from "./controllers/drag_drop_controller"
import DropdownController from "./controllers/dropdown_controller"
import DropdownMenuController from "./controllers/dropdown_menu_controller"
import ElementEnablerController from "controllers/element_enabler_controller"
import ElementValuesController from "./controllers/element_values_controller"
import EventDispatcherController from "./controllers/event_dispatcher_controller"
import ExchangeDealsMapController from "./controllers/react/exchange_deals_map_controller"
import ExchangeDealsObjectTableController from "./controllers/react/exchange_deals_object_table_controller"
import ExchangeMarketAssetsMapController from "./controllers/react/exchange_market_assets_map_controller"
import ExchangeMarketAssetsObjectTableController from "./controllers/react/exchange_market_assets_object_table_controller"
import ExchangeMarketDealsMapController from "./controllers/react/exchange_market_deals_map_controller"
import ExchangeMarketDealsObjectTableController from "./controllers/react/exchange_market_deals_object_table_controller"
import ExchangeMarketSalesMapController from "./controllers/react/exchange_market_sales_map_controller"
import ExchangeMarketSalesObjectTableController from "./controllers/react/exchange_market_sales_object_table_controller"
import ExchangeMarketTopicRecordsMapController from "./controllers/react/exchange_market_topic_records_map_controller"
import ExchangeMarketTopicRecordsObjectTableController from "./controllers/react/exchange_market_topic_records_object_table_controller"
import ExchangeTopicRecordsObjectTableController from "./controllers/react/exchange_topic_records_object_table_controller"
import FieldModalController from "./controllers/react/field_modal_controller"
import FieldSearchController from "./controllers/field_search_controller.js"
import FileDropController from "./controllers/file_drop_controller"
import FilmstripController from "./controllers/filmstrip_controller"
import FormController from "./controllers/form_controller"
import GlobalSearchController from "./controllers/application/global_search_controller"
import GlobalSearchResultsController from "./controllers/react/global_search_results_controller"
import GlobalTopicListController from "./controllers/react/global_topic_list_controller"
import OverviewLayoutController from "controllers/overview_layout_controller"
import HiddenInputController from "controllers/hidden_input_controller"
import HistoryController from "./controllers/react/history_controller"
import IFrameController from "./controllers/iframe_controller"
import IndeterminateCheckboxController from "controllers/indeterminate_checkbox_controller"
import InlineEditController from "./controllers/inline_edit_controller"
import InputValidatorController from "controllers/input_validator_controller"
import LightboxController from "./controllers/lightbox_controller"
import ListDealsController from "./controllers/react/list_deals_controller"
import ListFilterController from "./controllers/list_filter_controller"
import ListFormSectionsController from "./controllers/react/list_form_sections_controller"
import ListLayoutsController from "./controllers/react/list_layouts_controller"
import ListTasksController from "./controllers/react/list_tasks_controller"
import LocationListController from "./controllers/react/location_list"
import MapController from "./controllers/react/map_controller"
import MarketObjectOverviewController from "./controllers/react/market_object_overview_controller"
import MarketTopicListController from "./controllers/react/market_topic_list_controller"
import MissingFrameController from "./controllers/missing_frame_controller"
import MobileNavbarController from "./controllers/application/mobile_navbar_controller"
import MoneyFieldController from "controllers/money_field_controller"
import NavigationTabsOverflowController from "./controllers/navigation_tabs_overflow_controller"
import NewPortfolioController from "./controllers/react/new_portfolio_controller"
import NumberFormatController from "controllers/number_format_controller"
import PopupWindowController from "./controllers/popup_window_controller"
import ObjectListController from "./controllers/react/object_list_controller"
import ObjectOverviewController from "./controllers/react/object_overview_controller"
import ObjectTableController from "./controllers/react/object_table_controller"
import ObjectMapController from "./controllers/react/object_map_controller"
import ObjectMapTableSplitController from "./controllers/react/object_map_table_split_controller"
import OverviewTemplateController from "./controllers/react/overview_template_controller"
import OverviewRichTextTileController from "./controllers/overview_rich_text_tile_controller"
import PaginationController from "./controllers/pagination_controller"
import PercentFieldController from "controllers/percent_field_controller"
import PollerController from "./controllers/poller_controller"
import PortfolioAllocationsController from "./controllers/react/portfolio_allocations_controller"
import PortfolioObjectOverviewController from "./controllers/react/portfolio_object_overview_controller"
import PortfoliosObjectListController from "./controllers/react/portfolios_object_list_controller"
import PortfolioViewOrEditTLOController from "./controllers/react/portfolio_view_or_edit_tlo_controller"
import RecaptchaController from "./controllers/recaptcha_controller"
import ReorderableController from "controllers/reorderable_controller"
import ReactIFrameController from "./controllers/react/iframe_controller"
import ReactImportsController from "./controllers/react/imports_controller"
import RequirementsObjectTableController from "./controllers/react/requirements_object_table_controller"
import RequiredInputGroupController from "controllers/required_input_group_controller"
import RowLinkController from "controllers/row_link_controller"
import RowSelectorController from "controllers/row_selector_controller"
import SavedComparableDealsController from "controllers/react/saved_comparable_deals_controller"
import ScrollToElementController from "./controllers/scroll_to_element_controller"
import SelectNavigationController from "controllers/select_navigation_controller"
import SessionTokenController from "./controllers/session_token_controller"
import StaticMapController from "./controllers/react/static_map_controller"
import SubjectImportsController from "./controllers/react/subject_imports_controller"
import TabsController from "./controllers/tabs_controller"
import TimeZoneBannerController from "./controllers/application/time_zone_banner_controller"
import TooltipController from "./controllers/tooltip_controller"
import TopicRecordsFindComparablesController from "./controllers/react/topic_records_find_comparables_controller"
import TopicRecordsSelectReferencesController from "./controllers/react/topic_records_select_references_controller"
import TopicSavedComparablesController from "./controllers/react/topic_saved_comparables_controller"
import TurboFrameSrcController from "./controllers/application/turbo_frame_src_controller"
import TurboVisitController from "./controllers/turbo_visit_controller"
import GoogleMapController from "./controllers/google_map_controller"
import OpportunitiesMapController from "./controllers/exchange/opportunities/map_controller"
import ViewOrEditTLOController from "./controllers/react/view_or_edit_tlo_controller"
import ChatMessagesController from "./controllers/chat_messages_controller"
import ChatPanelController from "./controllers/chat_panel_controller"

import LocalTime from "local-time"

window.current = current
LocalTime.start()
document.addEventListener("turbo:morph", () => {
  LocalTime.run()
})

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

application.register("activity-preview", ActivityPreviewController)
application.register("activity-reference-bar", ActivityReferenceBarController)
application.register("attribute-toggle", AttributeToggleController)
application.register("autocomplete", AutocompleteController)
application.register("autocomplete-creation", AutocompleteCreationController)
application.register("autocomplete-menu", AutocompleteMenuController)
application.register("autocomplete-text-field", AutocompleteTextFieldController)
application.register("auto-download", AutoDownloadController)
application.register("browser-time-zone", BrowserTimeZoneController)
application.register("file-preview", FilePreviewController)
application.register("child-frame-navigator", ChildFrameNavigatorController)
application.register("class-replacement", ClassReplacementController)
application.register("class-toggle", ClassToggleController)
application.register("clipboard", ClipboardController)
application.register("counterparty-table", CounterpartyTableController)
application.register("confirm-dialog", ConfirmDialogController)
application.register("current-account-monitor", CurrentAccountMonitorController)
application.register("date-picker", DatePickerController)
application.register("dependable-frame", DependableFrameController)
application.register("dialog-modal", DialogModalController)
application.register("drag-drop", DragDropController)
application.register("dropdown", DropdownController)
application.register("dropdown-menu", DropdownMenuController)
application.register("element-enabler", ElementEnablerController)
application.register("element-values", ElementValuesController)
application.register("event-dispatcher", EventDispatcherController)
application.register("field-search", FieldSearchController)
application.register("flash-element", FlashElementController)
application.register("toast", ToastController)
application.register("react-field-modal", FieldModalController)
application.register("file-drop", FileDropController)
application.register("filmstrip", FilmstripController)
application.register("focus-new-item", FocusNewItemController)
application.register("form", FormController)
application.register("global-search", GlobalSearchController)
application.register("overview-layout", OverviewLayoutController)
application.register("hidden-input", HiddenInputController)
application.register("iframe", IFrameController)
application.register("indeterminate-checkbox", IndeterminateCheckboxController)
application.register("inline-edit", InlineEditController)
application.register("input-validator", InputValidatorController)
application.register("lightbox", LightboxController)
application.register("list-filter", ListFilterController)
application.register("missing-frame", MissingFrameController)
application.register("mobile-navbar", MobileNavbarController)
application.register("money-field", MoneyFieldController)
application.register(
  "navigation-tabs-overflow",
  NavigationTabsOverflowController
)
application.register("number-format", NumberFormatController)
application.register("popup-window", PopupWindowController)
application.register("overview-rich-text-tile", OverviewRichTextTileController)
application.register("pagination", PaginationController)
application.register("poller", PollerController)
application.register("percent-field", PercentFieldController)
application.register("react-action-panel", ActionPanelController)
application.register("react-asset-object-overview", AssetObjectOverviewController) // prettier-ignore
application.register("react-asset-topic-record-list", AssetTopicRecordListController) // prettier-ignore
application.register("react-asset-view-or-edit-tlo", AssetViewOrEditTLOController) // prettier-ignore
application.register("react-chart", ChartController)
application.register("checkbox-group", CheckboxGroupController)
application.register("checkbox-select-all", CheckboxSelectAllController)
application.register("react-child-portfolios-object-list", ChildPortfoliosObjectListController) // prettier-ignore
application.register("react-companies-object-list", CompaniesObjectListController) // prettier-ignore
application.register("react-comparable-deal-asset-object-overview", ComparableDealAssetObjectOverviewController) //prettier-ignore
application.register("react-comparable-deal-asset-view-or-edit-tlo", ComparableDealAssetViewOrEditTLOController) //prettier-ignore
application.register("react-comparable-deal-object-overview", ComparableDealObjectOverviewController) //prettier-ignore
application.register("react-comparable-deal-view-or-edit-tlo", ComparableDealViewOrEditTLOController) //prettier-ignore
application.register("react-contacts-object-table", ContactsObjectTableController) // prettier-ignore
application.register("react-date-range-select", DateRangeSelectController)
application.register("react-date-select", DateSelectController)
application.register("react-deal-asset-object-overview", DealAssetObjectOverviewController) // prettier-ignore
application.register("react-deal-asset-view-or-edit-tlo", DealAssetViewOrEditTLOController) // prettier-ignore
application.register("react-deal-assets", DealAssetsController)
application.register("react-deal-assets-object-list", DealAssetsObjectListController) // prettier-ignore
application.register("deal-bulk-actions", DealBulkActionsController)
application.register("react-deal-counterparties-object-list", DealCounterpartiesObjectListController) // prettier-ignore
application.register("react-deal-object-overview", DealObjectOverviewController)
application.register(
  "react-deal-organization-overview",
  DealOrganizationOverviewController
)
application.register("react-deal-topic-record-list", DealTopicRecordListController) // prettier-ignore
application.register("react-deal-view-or-edit-tlo", DealViewOrEditTLOController)
application.register("react-deals-find-comparable-deals", DealsFindComparableDealsController) // prettier-ignore
application.register("react-exchange-deals-map", ExchangeDealsMapController) // prettier-ignore
application.register("react-exchange-deals-object-table", ExchangeDealsObjectTableController) // prettier-ignore
application.register("react-exchange-market-assets-map", ExchangeMarketAssetsMapController) // prettier-ignore
application.register("react-exchange-market-assets-object-table", ExchangeMarketAssetsObjectTableController) // prettier-ignore
application.register("react-exchange-market-deals-map", ExchangeMarketDealsMapController) // prettier-ignore
application.register("react-exchange-market-deals-object-table", ExchangeMarketDealsObjectTableController) // prettier-ignore
application.register("react-exchange-market-sales-map", ExchangeMarketSalesMapController) // prettier-ignore
application.register("react-exchange-market-sales-object-table", ExchangeMarketSalesObjectTableController) // prettier-ignore
application.register("react-exchange-market-topic-records-map", ExchangeMarketTopicRecordsMapController) // prettier-ignore
application.register("react-exchange-market-topic-records-object-table", ExchangeMarketTopicRecordsObjectTableController) // prettier-ignore
application.register("react-exchange-topic-records-object-table", ExchangeTopicRecordsObjectTableController) // prettier-ignore
application.register("react-global-search-results", GlobalSearchResultsController) // prettier-ignore
application.register("react-global-topic-list", GlobalTopicListController)
application.register("react-history", HistoryController)
application.register("reorderable", ReorderableController)
application.register("react-iframe", ReactIFrameController)
application.register("react-imports", ReactImportsController)
application.register("react-list-deals", ListDealsController)
application.register("react-list-form-sections", ListFormSectionsController)
application.register("react-list-layouts", ListLayoutsController)
application.register("react-list-tasks", ListTasksController)
application.register("react-location-list", LocationListController)
application.register("react-map", MapController)
application.register("react-market-object-overview", MarketObjectOverviewController) // prettier-ignore
application.register("react-market-topic-list", MarketTopicListController) // prettier-ignore
application.register("react-new-portfolio", NewPortfolioController)
application.register("react-object-list", ObjectListController)
application.register("react-object-overview", ObjectOverviewController)
application.register("react-overview-template", OverviewTemplateController) // prettier-ignore
application.register("react-object-table", ObjectTableController)
application.register("react-object-map", ObjectMapController)
application.register("react-object-map-table-split", ObjectMapTableSplitController) // prettier-ignore
application.register("react-portfolio-allocations", PortfolioAllocationsController) // prettier-ignore
application.register("react-portfolio-object-overview", PortfolioObjectOverviewController) // prettier-ignore
application.register("react-portfolio-view-or-edit-tlo", PortfolioViewOrEditTLOController) // prettier-ignore
application.register("react-portfolios-object-list", PortfoliosObjectListController) // prettier-ignore
application.register("react-requirements-object-table", RequirementsObjectTableController) // prettier-ignore
application.register("react-saved-comparable-deals", SavedComparableDealsController) // prettier-ignore
application.register("react-static-map", StaticMapController)
application.register("react-subject-imports", SubjectImportsController)
application.register("react-topic-records-find-comparables", TopicRecordsFindComparablesController) // prettier-ignore
application.register("react-topic-records-select-references", TopicRecordsSelectReferencesController) // prettier-ignore
application.register("react-topic-saved-comparables", TopicSavedComparablesController) // prettier-ignore
application.register("react-view-or-edit-tlo", ViewOrEditTLOController)
application.register("recaptcha", RecaptchaController)
application.register("required-input-group", RequiredInputGroupController)
application.register("row-link", RowLinkController)
application.register("row-selector", RowSelectorController)
application.register("scroll-to-element", ScrollToElementController)
application.register("select-navigation", SelectNavigationController)
application.register("session-token", SessionTokenController)
application.register("tabs", TabsController)
application.register("time-zone-banner", TimeZoneBannerController)
application.register("tooltip", TooltipController)
application.register("turbo-frame-src", TurboFrameSrcController)
application.register("turbo-visit", TurboVisitController)
application.register("google-map", GoogleMapController)
application.register("opportunities-map", OpportunitiesMapController)
application.register("chat-messages", ChatMessagesController)
application.register("chat-panel", ChatPanelController)

window.Turbo.StreamActions.redirect = function () {
  window.Turbo.visit(this.target)
}

window.Turbo.StreamActions.reload = function () {
  this.targetElements.forEach((frame) => frame.reload())
}

window.Turbo.config.forms.confirm = (message) => {
  let confirmOpts = {}
  const dialog = document.getElementById("turbo-confirm-dialog")
  const confirmDialogController =
    application.getControllerForElementAndIdentifier(dialog, "confirm-dialog")

  // This resolves limited support for using turbo_confirm with link_to
  // https://github.com/hotwired/turbo/issues/811
  try {
    confirmOpts = JSON.parse(message)
  } catch {
    confirmOpts["message"] = message
  }

  return confirmDialogController.open(
    confirmOpts.message,
    confirmOpts.message_content,
    confirmOpts.title,
    confirmOpts.button_text
  )
}

document.addEventListener("turbo:before-morph-element", (event) => {
  if (
    event.target.parentNode.tagName == "BODY" &&
    event.target.id != "turbo-morph-body"
  ) {
    event.preventDefault()
  }
})

// Re-initialize trix editor after morphing
// https://github.com/hotwired/turbo-rails/issues/533
document.addEventListener("turbo:morph-element", (event) => {
  if (event.target.tagName == "TRIX-EDITOR") {
    const originalTrixEditor = event.target
    const clonedTrixEditor = originalTrixEditor.cloneNode()

    const editorContent = originalTrixEditor.getAttribute("data-value")

    setTimeout(() => {
      originalTrixEditor.replaceWith(clonedTrixEditor)
      clonedTrixEditor.editor.insertHTML(editorContent)
    })
  }
})

document.addEventListener("DOMContentLoaded", () => {
  registerSentry()

  const preventDefault = (event) => {
    event.preventDefault()
  }

  window.addEventListener("dragover", preventDefault)
  window.addEventListener("drop", preventDefault)

  // prevent drag and drop attachment in trix editor
  document.addEventListener("trix-file-accept", (event) => {
    event.preventDefault()
  })
})
